import OldReward from './OldReward';

export default OldReward;
